<template>
  <div id="compareContractsPage">
    <MainLayout>
      <b-row id="compareMultipleContracts">
        <CompareMultipleContracts />
      </b-row>
    </MainLayout>
  </div>
</template>

<script>
import MainLayout from "@/layouts/MainLayout.vue";
import CompareMultipleContracts from "@/components/compareMultiple/CompareMultipleContracts.vue";

export default {
  components: {
    MainLayout,
    CompareMultipleContracts,
  },
};
</script>

<style scoped></style>
